  import { useEffect, useRef, useState } from "react";
  import { useSceneNodes } from "./SecondaryScene";
  import { useFrame } from "@react-three/fiber";
  import gsap from "gsap";
  import * as THREE from "three";
  import RocketSmoke from "../effect/RocketSmoke";
  import FireParticles from "../../shaders/Fire";
  import useFlowStore from "../store/flowStore";
  import CameraManager from "../manager/CameraManager";
  import { OrbitControls } from "@react-three/drei";

  // Helper d’attachement des flames au bon node (inchangé)
  function UnderFuséeNode({ rocketRef, nodeName = "fusee_for_bake", children }) {
    const group = useRef();
    useEffect(() => {
      if (!rocketRef.current) return;
      const node = rocketRef.current.getObjectByName(nodeName);
      if (node && group.current && !node.children.includes(group.current)) {
        node.add(group.current);
      }
      return () => {
        if (node && group.current && node.children.includes(group.current)) {
          node.remove(group.current);
        }
      };
    }, [rocketRef, nodeName]);
    return <group ref={group}>{children}</group>;
  }

  export default function FuseeScene({ debugRocket = false, interactUIRef }) {
    const { rocket } = useSceneNodes();
    const { fuseeShouldLaunch, nextStep, currentStep } = useFlowStore();

    const rocketRef = useRef();
    const smokeRef = useRef();

    const flameMatL = useRef();
    const flameMatR = useRef();

    const [showEffects, setShowEffects] = useState(false);
    const [hasLaunched, setHasLaunched] = useState(false);
    const [flamesReady, setFlamesReady] = useState(false);

    const [smokePosition, setSmokePosition] = useState([0, 4, -25]);

    useEffect(() => {
      if (rocketRef.current) {
        rocketRef.current.position.set(0, 0, 0);
        rocketRef.current.rotation.set(0, 0, 0);
      }
    }, [rocket]);

    useEffect(() => {
      if (showEffects && flamesReady) {
        gsap.to([flameMatL.current, flameMatR.current], {
          uOpacity: 1,
          duration: 2,
        });
      }

      if (smokeRef.current) {
        // log world position de la smoke (un seul sprite suffit)
        const worldPos = new THREE.Vector3();
        smokeRef.current.getWorldPosition(worldPos);
        // Pour spam moins : log seulement au step 11
        if (useFlowStore.getState().currentStep === 11) {
          console.log(
            "Smoke world Y:",
            worldPos.y,
            "smokeRef local Y:",
            smokeRef.current.position.y
          );
        }
      }
    }, [showEffects, flamesReady]);

    useFrame(() => {
      if (flameMatL.current) flameMatL.current.uTime = performance.now() / 1000;
      if (flameMatR.current) flameMatR.current.uTime = performance.now() / 1000;
    });

    useEffect(() => {
      if (fuseeShouldLaunch && !hasLaunched) {
        launchRocket();
      }
    }, [fuseeShouldLaunch]);

    const launchRocket = () => {
      if (hasLaunched) return;
      setHasLaunched(true);
      setShowEffects(true);
      CameraManager.playAnimationFrom({
        startTime: 120 / 30, // 100 frames at 30 FPS
      });

      setTimeout(() => {
        nextStep(() => {
          console.log("END UI CALLED");
        });
      }, 10000);
      // CameraManager.playAnimation(() => {
      //   nextStep(() => {
      //     console.log("END UI CALLED");
      //   });
      // }, 15000);
    };

    const handleMatL = (mat) => {
      flameMatL.current = mat;
      if (flameMatL.current && flameMatR.current) setFlamesReady(true);
    };
    const handleMatR = (mat) => {
      flameMatR.current = mat;
      if (flameMatL.current && flameMatR.current) setFlamesReady(true);
    };

    if (!rocket) return null;

    return (
      <>
        {/* <OrbitControls /> */}
        {/* Smoke placée dynamiquement SOUS la fusée */}

        {showEffects && (
        <RocketSmoke ref={smokeRef} position={smokePosition} active={true} />
        )} 
        <group ref={rocketRef}>
          <primitive object={rocket} />
          {/* Flames accrochées à la fusée */}
          {showEffects && (
            <UnderFuséeNode rocketRef={rocketRef} nodeName="fusee_for_bake">
              <group position={[-15, -48, 0]}>
                <FireParticles count={100} onMaterialReady={handleMatL} />
              </group>
              <group position={[15, -48, 0]}>
                <FireParticles count={100} onMaterialReady={handleMatR} />
              </group>
            </UnderFuséeNode>
          )}
        </group>
      </>
    );
  }
